import React, { Component } from "react";
import { withRedux, displayError } from "helpers";
import * as styles from "./authentication.styles";
import { H5 } from "../newStyles.styles";
import Button from "@material-ui/core/Button";
import { TextField, Tooltip } from "@material-ui/core";

class GuestSignup extends Component {
  state = {
    firstName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    email: "",
    phone: "",
    admin: 1,
    disabled: false,
    isPreFilled: false,
  };

  // componentWillUpdate(currentProp) {
  //   const { formPreFillInfo } = currentProp;
  //   if (formPreFillInfo.email && !this.state.email) {
  //     this.setState({
  //       ...this.state,
  //       ...formPreFillInfo,
  //       isPreFilled: true,
  //     });
  //   }
  // }

  update = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: "",
    });
  };

  signup = (e) => {
    e.preventDefault();
    const { disabled, confirmPassword, ...user } = this.state;
    const { firstName, lastName, email, phone, password } = user;

    if (!firstName || !lastName)
      return displayError("Please fill out first and last name.");
    if (!email) return displayError("Email can't be empty.");
    if (!phone) return displayError("Phone can't be empty");

    // if (confirmPassword === password) {

    // } else {
    //   displayError("Password must match!");
    // }

    if (password != "") {
      // console.log("creating an account");

      this.props.actions.signup(user);
    } else {
      // console.log("guest checking out....");
      this.props.actions.updateCustomerInfo({
        email: email,
        firstName: firstName,
        lastName: lastName,
        phone: phone,
      });
    }
  };

  render() {
    const {
      firstName,
      lastName,
      password,
      confirmPassword,
      email,
      phone,
      disabled,
      isPreFilled,
    } = this.state;

    const { width, customColor, buttonText } = this.props;

    return (
      <div
        style={{
          padding: "0px 15px 15px 15px",
          alignSelf: "center",
          backgroundColor: "white",
        }}
      >
        {!buttonText && (
          <H5 style={{ textAlign: "center", marginBlockStart: "0px" }}>
            Sign Up
          </H5>
        )}

        <form
          autoComplete="new-password"
          className={styles.flexColumn}
          onSubmit={this.signup}
        >
          <div className={styles.flexRow}>
            <input
              autoComplete="new-password"
              className={styles.inputStyle}
              autoFocus="firstName"
              type="text"
              name="firstName"
              placeholder="First Name"
              value={firstName}
              onChange={this.update}
              style={{ width: buttonText ? "65%" : "50%" }}
              required
            />
          </div>
          <div className={styles.flexRow}>
            {" "}
            <input
              autoComplete="new-password"
              className={styles.inputStyle}
              // autoFocus='lastName'
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={lastName}
              onChange={this.update}
              style={{ width: buttonText ? "65%" : "50%" }}
              required
            />
          </div>
          <div className={styles.flexRow}>
            <input
              style={{
                background: isPreFilled ? "#dcdcdc" : "white",
                width: buttonText ? "65%" : "50%",
              }}
              autoComplete="new-password"
              className={styles.inputStyle}
              // autoFocus='email'
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              disabled={isPreFilled}
              onChange={this.update}
              required
            />
          </div>
          <div className={styles.flexRow}>
            <input
              style={{
                background: isPreFilled ? "#dcdcdc" : "white",
                width: buttonText ? "65%" : "50%",
              }}
              autoComplete="new-password"
              className={styles.inputStyle}
              // autoFocus='email'
              type="phone"
              name="phone"
              placeholder="Phone"
              value={phone}
              disabled={isPreFilled}
              onChange={this.update}
              required
            />
          </div>
          <div className={styles.guestPromptContainer}>
            <h3
              className={styles.greyText}
              style={{
                color: this.props.activeApp.view.navigation.navBarColor,
              }}
            >
              Optional: Create an Account
            </h3>
            <p className={styles.greyText}>
              Store payment information, retrieve orders, get exclusive offers,
              and join incredible rewards programs across Mobile360!
            </p>
            <div className={styles.flexRow}>
              <input
                autoComplete="new-password"
                className={styles.inputStyle}
                type="password"
                name="password"
                // autoFocus='password'
                placeholder="Password"
                value={password}
                onChange={this.update}
                style={{ width: buttonText ? "65%" : "50%" }}
                // required
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "15px",
            }}
          >
            <styles.WebButton
              background={
                customColor
                  ? this.props.activeApp.view.navigation.navBarColor
                  : "#89d2d3"
              }
              type={"submit"}
            >
              {buttonText ? buttonText : "Sign Up"}
            </styles.WebButton>
          </div>
          {!buttonText && (
            <p
              style={{
                color: "black",
                margin: "15px 0px",
                textAlign: "center",
                fontSize: "14px",
              }}
            >
              By using this website, you're agreeing to our{" "}
              <a style={{ cursor: "pointer" }} href="/terms" target="_blank">
                Terms & Conditions
              </a>{" "}
              and{" "}
              <a
                style={{ cursor: "pointer" }}
                href="/privacy_policy"
                target="_blank"
              >
                Privacy Policy
              </a>
            </p>
          )}
        </form>
      </div>
    );
  }
}

export default withRedux(GuestSignup);
